/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
export default {
  // parse a float from a string, logging and returning a default value if an error occurs
  parseFloat(string, options = {}) {
    return this.getValue(Number.parseFloat(string), options)
  },

  // parse an integer from a string, logging and returning a default value if an error occurs
  parseInt(string, options = {}) {
    return this.getValue(Number.parseInt(string), options)
  },

  // format a number for display, including decimal values only as necessary
  formatNumberForDisplay(number, { maxDecimals = 2 } = {}) {
    number = this.getValue(number)

    // integer numbers:
    // display with no decimal value
    //
    // examples: 0 => '0', 0.0 => '0', 1.0 => '1'
    if (Number.isInteger(number)) {
      return number.toFixed(0)
    }

    // non-integer numbers:
    // display with the minimum number of decimals to appear as a non-integer
    //
    // examples: 0.1 => '0.1', 0.11 => '0.1', 0.3333333 => '0.3'
    for (let decimals = 1; decimals <= maxDecimals; decimals++) {
      let string = number.toFixed(decimals)

      if (Number.parseFloat(string) !== Number.parseInt(string)) {
        return string
      }
    }

    // display with no decimal value otherwise
    return number.toFixed(0)
  },

  // get a value, guarding against NaN values
  getValue(
    value,
    {
      defaultValue = 0,
      errorMessage = 'Unexpected NaN value. Ensure proper input validation.'
    } = {}
  ) {
    if (Number.isNaN(value) || value === undefined) {
      // allow the error message to be disabled when errorMessage is set to false
      if (errorMessage !== false) {
        console.error(errorMessage)
      }

      return defaultValue
    }

    return value
  },

  detectDeviceType() {
    let screenWidth = window.screen.width
    return screenWidth <= 640 ? 'mobile' : 'desktop'
  }
}
